import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'

export class CompanyOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name
    }));
  }

  render () {
    return (
      <div class="main">
<p style={{textAlign: "center"}}>
ПУБЛИЧНАЯ ОФЕРТА<br/>
о заключении договора на использование платформы «Planna»</p>

<p style={{display: "none"}}>
  г. [Ваш город]
«» ___________ 20г.
  , в лице [Должность, ФИО], действующего на основании [Устава]</p>

<p>ООО "Планна", именуемое в дальнейшем «Администрация», предлагает любому юридическому лицу или индивидуальному предпринимателю (далее — «Пользователь») заключить настоящий Договор присоединения на изложенных ниже условиях (далее — «Договор» или «Оферта»).</p>

<ol><li>ТЕРМИНЫ
<ol>
<li>Акцепт — полное и безоговорочное принятие Пользователем условий настоящей Оферты путём совершения конклюдентных действий: регистрации и активации учётной записи Поставщика Услуг на Платформе.</li>
<li>Платформа Planna — программно-аппаратный комплекс, доступный по адресу [planna.app] и через мобильные приложения.</li>
<li>Поставщик Услуг (Партнёр) — Пользователь, успешно прошедший регистрацию и акцептовавший Оферту, размещающий информацию об услугах для бронирования и/или аренды клиентами через Платформу.</li>
<li>Услуги — любые предложения Поставщика, доступные для бронирования/аренды через Платформу, включая, но не ограничиваясь: столики в заведениях питания, номера в отелях и апартаментах, записи на приёмы (парикмахерские, спа, медицинские и иные услуги), аренду движимого и недвижимого имущества (транспорт, инструменты, оборудование, одежда, жильё и т.д.).</li>
<li>Дополнительные сервисы Администрации — необязательные к использованию технологические услуги, оказываемые Администрацией Поставщику для расширения функционала Платформы, включая, но не ограничиваясь: приём онлайн-платежей (эквайринг) и отправку SMS-уведомлений клиентам.</li>
</ol></li>
<li>ПРЕДМЕТ ДОГОВОРА. БЕСПЛАТНЫЙ БАЗОВЫЙ ФУНКЦИОНАЛ
<ol>
<li>Гарантия бесплатного использования.<br/>
Администрация гарантирует, что предоставление Поставщику права использования базового функционала Платформы, указанного в п. 2.2, является абсолютно бесплатным, неограниченным по сроку («навсегда») и не зависит от:
<ul>
<li>Объёма бронирований или количества транзакций, совершённых через Платформу.</li>
<li>Размера, оборота или иных финансовых показателей компании Поставщика.</li>
<li>Количества сотрудников, точек оказания услуг или размещённых предложений.</li>
</ul>
</li>
<li>Бесплатный базовый функционал.<br/>
На условиях, указанных в п. 2.1, Администрация предоставляет Поставщику право использовать полный базовый функционал Платформы для:
<ul>
<li>Создания и ведения профиля компании.</li>
<li>Размещения любых Услуг (включая услуги бронирования и предложения по аренде) с описанием, графиком работы, ценами и условиями.</li>
<li>Приёма, подтверждения, изменения и отмены онлайн-бронирований и заявок от клиентов.</li>
<li>Использования интеллектуального календаря и инструментов управления расписанием, включая уникальную функцию синхронизации рабочего и личного календарей сотрудников для предотвращения конфликтов.</li>
<li>Просмотра аналитики по бронированиям и загрузке.</li>
<li>Использования функции «Поиск партнёра» для формирования совместных бронирований клиентов.</li>
</ul>
</li>
<li>Отсутствие платы за базовый функционал.<br/>
За доступ и использование функционала, указанного в п. 2.2, Администрация не взимает с Поставщика и не будет взимать в будущем абонентскую плату, плату за подключение, комиссию (%) с суммы бронирования или иные регулярные платежи.
</li>
</ol></li>
<li>ДОПОЛНИТЕЛЬНЫЕ СЕРВИСЫ (ЭКВАЙРИНГ И SMS). КОМИССИЯ
<ol>
<li>Поставщик вправе, но не обязан подключать и использовать Дополнительные сервисы Администрации.</li>
<li>Эквайринг. В случае подключения сервиса приёма онлайн-платежей:<br/>
<ul>
<li>Администрация обеспечивает техническую интеграцию с платёжными шлюзами.</li>
<li>Администрация удерживает с каждой успешной транзакциикомиссию за эквайринг, которая покрывает фактические затраты Администрации на проведение платежа (тарифы банков/платёжных систем) и включает технологическую надбавку (маржа) Администрации.</li>
</ul>
</li>
<li>SMS-уведомления. В случае подключения сервиса SMS-информирования:
<ul>
<li>Администрация обеспечивает отправку служебных сообщений клиентам (подтверждение, напоминание).</li>
<li>Администрация удерживает комиссию за отправку SMS, которая покрывает фактические затраты Администрации на услуги сервисов рассылок и включает технологическую надбавку (маржа) Администрации.</li>
</ul>
</li>
<li>Размер комиссий за каждый из Дополнительных сервисов, порядок их расчёта и удержания публикуются в Личном кабинете Поставщика в разделе «Тарифы» и являются неотъемлемой частью настоящей Оферты.</li>
<li>Администрация оставляет за собой право изменять размер комиссий с предварительным уведомлением Поставщика за 15 (пятнадцать) календарных дней путём публикации новых тарифов в Личном кабинете.</li>
</ol></li>
<li>РАСЧЁТЫ И ВЫПЛАТА ДЕНЕЖНЫХ СРЕДСТВ ПОСТАВЩИКУ
<ol>
<li>Денежные средства, полученные от клиентов через сервис эквайринга Администрации за Услуги Поставщика, за вычетом применимых комиссий (п. 3), аккумулируются Администрацией.</li>
<li>Выплата накопленных средств Поставщику производится по запросу Поставщика из Личного кабинета, при условии наличия минимальной выплачиваемой суммы, установленной в Личном кабинете.</li>
<li>Администрация вправе удержать дополнительную комиссию за перевод денежных средств Поставщику, если затраты на проведение такого перевода (комиссия банка, платёжной системы) не включены в иные комиссии по разделу 3. Размер и условия применения данной комиссии доводятся до Поставщика до момента инициации выплаты.</li>
</ol></li>
<li>ПРЕМИУМ-УСЛУГИ
<ol>
<li>Администрация оставляет за собой право в будущем вводить иные премиум-услуги (например, продвижение услуг (рекламу) в интерфейсе Платформы, расширенную аналитику, кастомизированные интеграции). Подключение к таким сервисам будет исключительно добровольным и регулироваться отдельными офертами.</li>
<li>Гарантия сохранения бесплатного базового доступа.<br/>
Неподключение Поставщика к любым Дополнительным (Раздел 3) или Премиум-услугам (п. 5.1) никоим образом не ограничивает, не ухудшает и не отменяет его права на бесплатное, полное и бессрочное использование базового функционала Платформы, как это гарантировано в Разделе 2.
</li>
</ol></li>
<li>ОБЯЗАННОСТИ ПОСТАВЩИКА
<ol>
<li>При размещении Услуг на Платформе Поставщик обязуется предоставлять достоверную, полную и актуальную информацию.</li>
<li>Поставщик обязуется своевременно обрабатывать входящие бронирования (подтверждать, отклонять).</li>
<li>Поставщик обязуется добросовестно исполнять обязательства, принятые перед клиентами через Платформу.</li>
<li>Поставщик несёт полную ответственность за соответствие размещённых Услуг требованиям действующего законодательства.</li>
</ol></li>
<li>РЕГИСТРАЦИЯ, АКЦЕПТ И ДАННЫЕ СТОРОН
<ol>
<li>Реквизиты и подпись Администрации (Оферента):
<ul>
<li>Наименование: [Ваше полное юридическое название]</li>
<li>ИНН/КПП: [Ваши ИНН, КПП]</li>
<li>Юридический адрес: [Ваш юридический адрес]</li>
<li>Подпись уполномоченного лица: Настоящая публичная оферта является юридически значимым электронным документом, подписанным простой электронной подписью в виде факта её публикации на официальном сайте Администрации по адресу: [planna.ru/companyoffer].</li>
</ul>
</li>
<li>Данные и акцепт Поставщика (Пользователя):
<ul>
<li>Акцептом Оферты считается последовательное выполнение Пользователем при регистрации всех требуемых действий: заполнение полей с данными и проставление отметки (галочки) в специальном поле «Я согласен с условиями Договора-оферты».</li>
<li>Подписью Пользователяна данном Договоре признаются совершённые им действия по акцепту, а также логин и пароль учётной записи, используемые в дальнейшем для входа в Платформу.</li>
<li>Реквизиты Пользователядля целей данного Договора — это данные, указанные им при регистрации (наименование организации, ИНН, адрес, контактный email и телефон). Пользователь гарантирует их достоверность.</li>
</ul>
</li>
</ol></li>
<li>МАРКЕТИНГ И ПРОДВИЖЕНИЕ
<ol>
<li>Информационный стенд. В целях продвижения Платформы и информирования клиентов, Поставщик обязуется в течение 30 (тридцати) календарных дней с момента активации аккаунта разместить в месте оказания Услуг (на ресепшене, в видимой зоне зала, в кабинете и т.д.) информационный стенд (стикер, табличку, постер).</li>
<li>Содержание стенда.Стенд должен содержать информацию о том, что бронирование Услуг Поставщика осуществляется через систему «Planna», а также QR-код, ведущий на персональную страницу Поставщика в Платформе. Данная страница содержит информацию только об Услугах данного Поставщика и предоставляет клиенту возможность моментального онлайн-бронирования.</li>
<li>Материалы.Администрация предоставляет Поставщику в Личном кабинете:
<ul>
<li>Ссылку для скачиванияготового макета стенда, адаптированного под стандарты Платформы.</li>
<li>Персональную ссылкуи QR-код, ведущие на страницу Поставщика.</li>
<li>Инструменты для кастомизациимакета (возможность добавить собственный баннер, логотип, выбрать цветовую схему) с последующей генерацией файла для печати.</li>
</ul>
</li>
<li>Неисполнение обязанности по размещению информационного стенда не является основанием для прекращения или ограничения доступа к Платформе, но может учитываться Администрацией при рассмотрении заявок на участие в рекламных и партнёрских программах.</li>
</ol></li>
<li>ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
<ol>
<li>Настоящая Оферта вступает в силу с момента её публикации и действует до отзыва. Договор считается заключённым с момента Акцепта.</li>
<li>Администрация вправе изменять условия настоящей Оферты, за исключением гарантий, данных в Разделе 2 (Бесплатный базовый функционал). Изменения иных условий вступают в силу через 30 (тридцать) календарных дней после публикации новой редакции на сайте, если иной срок не указан особо.</li>
<li>При несогласии с изменениями Поставщик вправе расторгнуть Договор, деактивировав аккаунт в течение срока действия старых условий. Продолжение использования Платформы после вступления изменений в силу считается их принятием.</li>
</ol></li>
</ol>
---
<p>
Факт публикации и действия Администрации,
совершённые в соответствии с п. 7.1,
признаются её юридически значимой подписью под настоящей Офертой.
</p>
      </div>
    );
  }
}
